export default __webpack_public_path__ + "static/media/cross.ae506d6c.svg";